import { useEffect } from 'react';

import { useConfig } from '@/shared/contexts/config/useConfig';

import { initRum } from './apm';
import { useApmUserContext } from './useApmUserContext';

export const RumInitializer = () => {
  const { apmUrl, env } = useConfig();

  useEffect(() => {
    initRum({
      apmUrl,
      env,
      serviceVersion: import.meta.env.CLIENT_SERVICE_VERSION,
    });
  }, [apmUrl, env]);

  useApmUserContext();

  return null;
};
